import React, { Component } from "react";
import Footer from "../../components/Footer/footer";
import NavbarPage from "../../components/Navbar/Navbar_Page";
import SeoHead from "../../components/SeoHead";
import EmbedSection from "./section";
import PartnerSection from "./partnerSection";
import { ProductSwitcher } from "./apiDocsShared";
import "./api-docs.css";

function normalizeProduct(raw) {
  if (raw === "partner" || raw === "enterprise") return "partner";
  if (raw === "embed" || raw === "merchant" || raw === "widget") return "embed";
  return "embed";
}

function readProductFromUrl() {
  try {
    if (typeof window !== "undefined") {
      if (
        window.location.pathname === "/enterprise-api-docs" ||
        window.location.pathname === "/partner-api-docs"
      ) {
        return "partner";
      }
    }
    const q = new URLSearchParams(window.location.search);
    return normalizeProduct(q.get("product") || "embed");
  } catch {
    return "embed";
  }
}

class ApiDocsIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: readProductFromUrl(),
      navItems: [
        { id: 1, idnm: "home", navheading: "Home" },
        { id: 2, idnm: "services", navheading: "Services" },
        { id: 3, idnm: "features", navheading: "Features" },
        { id: 4, idnm: "clients", navheading: "Clients" },
        { id: 6, idnm: "pricing", navheading: "Plans" },
      ],
      pos: document.documentElement.scrollTop,
      imglight: false,
      navClass: "",
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  setProduct = (product) => {
    this.setState({ product });
    try {
      const url = new URL(window.location.href);
      if (product === "partner") {
        url.searchParams.set("product", "partner");
        if (url.pathname === "/enterprise-api-docs") {
          url.pathname = "/partner-api-docs";
        }
      } else {
        url.searchParams.set("product", "embed");
        if (url.pathname === "/enterprise-api-docs" || url.pathname === "/partner-api-docs") {
          url.pathname = "/api-docs";
        }
      }
      window.history.replaceState({}, "", url);
    } catch {
      /* noop */
    }
  };

  scrollNavigation = () => {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > this.state.pos) {
      this.setState({ navClass: "nav-sticky", imglight: false });
    } else {
      this.setState({ navClass: "", imglight: false });
    }
  };

  render() {
    const { product } = this.state;
    const isPartner = product === "partner";
    const seoPath = isPartner ? "/api-docs?product=partner" : "/api-docs?product=embed";
    return (
      <React.Fragment>
        <SeoHead
          title={
            isPartner
              ? "Partner API documentation | QikTruck"
              : "Website delivery widget docs | QikTruck"
          }
          description={
            isPartner
              ? "REST API for South African developers: quotes, booking, tracking, and cancellation. Sandbox qt_test keys and production qt_live keys."
              : "Embed live delivery quotes on your e-commerce store. Install the QikTruck widget and let shoppers checkout on QikTruck."
          }
          pathname={seoPath}
          jsonLd={{
            "@context": "https://schema.org",
            "@type": "TechArticle",
            headline: isPartner ? "QikTruck Partner API" : "QikTruck website widget",
            url: `https://book.qiktruck.co.za${seoPath}`,
            author: { "@type": "Organization", name: "QikTruck" },
          }}
        />
        <NavbarPage
          navItems={this.state.navItems}
          navClass={this.state.navClass}
          imglight={this.state.imglight}
        />
        <div className={"qt-api-docs-shell qt-api-docs-shell--" + product}>
          {product === "partner" ? (
            <PartnerSection
              productSwitcher={<ProductSwitcher product={product} onChange={this.setProduct} />}
            />
          ) : (
            <EmbedSection
              productSwitcher={<ProductSwitcher product={product} onChange={this.setProduct} />}
            />
          )}
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default ApiDocsIndex;
